import { render, staticRenderFns } from "./IP_FindingSummaryDxPrintable.vue?vue&type=template&id=cafa9272&scoped=true&"
import script from "./IP_FindingSummaryDxPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_FindingSummaryDxPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_FindingSummaryDxPrintable.vue?vue&type=style&index=0&id=cafa9272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafa9272",
  null
  
)

export default component.exports